import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import AdvantagesContent from './components/AdvantagesContent';

export default function AdvantagesPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '康永優勢｜天然原料・整合服務・少量訂單｜康永生技',
    description: '康永生技四大核心優勢：堅持天然原料、創造三贏、整合專業服務、少量訂單支援，幫助品牌降低進入門檻與市場風險。',
    keywords: '康永優勢,天然原料,少量代工,整合服務,保健食品代工優勢',
    lang: 'zh-TW',
    canonicalPath: '/home/advantages',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="康永優勢｜天然原料・整合服務・少量訂單｜康永生技" pageDescription="康永生技四大核心優勢：堅持天然原料、創造三贏、整合專業服務、少量訂單支援，幫助品牌降低進入門檻與市場風險。" pageUrl={`${siteUrl}/home/advantages`} />
      <AdvantagesContent />
    </Layout>
  );
}